module.exports = __webpack_public_path__ + "static/media/dj.addb4ed5.svg";